import React, { useState, useCallback } from 'react';
import { Container, Button, TextField, Tab, Tabs, Card, Box, List, ListItem, ListItemIcon } from '@material-ui/core';
import { FlagIcon } from 'react-flag-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useText, useGetData, usePutData } from '../../hooks'
import * as Api from '../../service'

const fields = ['phone', 'email', 'address', 'footer_title', 'footer_description']
const initForm = {
    phone_ru: '',
    phone_en: '',
    email_ru: '',
    email_en: '',
    address_en: '',
    address_ru: '',
    footer_title_en: '',
    footer_title_ru: '',
    footer_description_en: '',
    footer_description_ru: '',
}
const Contact = () => {
    const [data, loading, refresh] = useGetData(Api.main.getContacts)
    const updateContacts = usePutData(Api.main.updateContacts, refresh)
    const [tab, setTab] = useState('ru');
    const [text, setText, textChange] = useText(data?.item || initForm)

    const submitForm = useCallback(async e => {
        e.preventDefault()
        const form = new FormData()
        Object.keys(initForm).forEach(field => {
            form.append(field, text[field])
        })
        updateContacts(form)
    }, [text]);

    return (
        <Container>
            <Card className="shadow-xxl px-4 py-2">
                <List component="div" className="my-3 nav-tabs nav-tabs-primary d-flex">
                    <ListItem
                        button
                        disableRipple
                        selected={tab === 'ru'}
                        onClick={() => {
                            setTab('ru');
                        }}>
                        <FlagIcon code="RU" size={44} />
                        <div className="divider" />
                    </ListItem>
                    <ListItem
                        button
                        disableRipple
                        selected={tab === 'en'}
                        onClick={() => {
                            setTab('en');
                        }}>
                        <FlagIcon code="US" size={44} />
                        <div className="divider" />
                    </ListItem>
                </List>
                <Box component='form' onSubmit={submitForm}>
                    {fields.map(el =>
                        <TextField
                            variant="outlined"
                            className="mb-4"
                            error={false}
                            label={el.split('_').join(' ')}
                            fullWidth
                            name={`${el}_${tab}`}
                            value={text[`${el}_${tab}`]}
                            onChange={textChange}
                        />
                    )}
                    <div className="text-center">
                        <Button type='submit' variant="contained" className="btn-primary m-2">
                            <span className="btn-wrapper--label">Save</span>
                            <span className="btn-wrapper--icon">
                                <FontAwesomeIcon icon={['far', 'save']} />
                            </span>
                        </Button>
                    </div>
                </Box>
            </Card>

        </Container>
    );
};

export default Contact;
